export default "__VITE_ASSET__Tc7n70aV__"